import { useContext, useEffect, useMemo, useState } from 'react';
import CustomDataTable from '../../../components/CustomDataTable';
import { useCurrentAccount } from '../../../hooks/useCurrentAccount';
import { FollowUpService } from '../../../services/FollowUpService';
import { FollowUpAgentsContext } from '../../../context/FollowUpAgentsContext';
import { APPS } from '../../../constants';
import { useTranslation } from 'react-i18next';
import useRequest from '../../../hooks/useRequest';
import LoaderSmall from '../../../components/LoaderSmall';
export default function AgentChatView() {
    const { t } = useTranslation();
    const { account } = useCurrentAccount();
    const {call, isRequesting} = useRequest();
    const { agentSelected } = useContext(FollowUpAgentsContext);
    const [rows, setRows] = useState([]);
    const [closedTickets, setClosedTickets] = useState([]);
    const [liveTickets, setLiveTickets] = useState([]);
    const onlyNumber = /\D+/g;
    const columns = [
        {
            name: t('follow-up.agents.chat-view.clients-row'),
            sortable: false,
            selector: row => row?.name_client,
            cell: row => {
                return (
                    <div className='d-flex'>
                        {(() => {
                            switch (row?.app.toUpperCase()) {
                                case APPS.WHATSAPP_BUSINESS:
                                    return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/waBusiness.jpg" alt="Image Description" /></span>;
                                case APPS.WHATSAPP_STANDAR:
                                    return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/waStandard.jpg" alt="Image Description" /></span>;
                                case APPS.SMS:
                                    return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/smsLogo.jpg" alt="Image Description" /></span>;
                                case APPS.RCS:
                                    return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/rcsLogo.jpg" alt="Image Description" /></span>;
                                default:
                                    return <div></div>;
                            }
                        })()}
                        <div className='px-2'>
                            {row?.name_client ? (
                                <div>
                                    <h5 className="text-nowrap mb-0">{row?.name_client}</h5>
                                    <p className='text-nowrap mb-0'>{row?.chat_number.replace(onlyNumber, '')}</p>
                                </div>
                            ) :
                                (
                                    <h5 className='text-nowrap mb-0'>{row?.chat_number.replace(onlyNumber, '')}</h5>
                                )}
                        </div>
                    </div>

                )
            },
        },
        {
            name: t('follow-up.agents.chat-view.status-row'),
            sortable: false,
            selector: row => row?._status_ticket,
            cell: row => {
                return (
                    <div>
                        {
                            ((() => {
                                switch (row?._status_ticket.toLowerCase()) {
                                    case 'tsa':
                                        return <span className='badge bg-danger'>{t('follow-up.agents.chat-view.tsa-status')}</span>;
                                    case 'tsrc':
                                        return <span className='badge bg-warning font-black'>{t('follow-up.agents.chat-view.tsrc-status')}</span>;
                                    case 'tsra':
                                        return <span className='badge bg-danger'>{t('follow-up.agents.chat-view.tsra-status')}</span>;
                                    default: <span className='badge bg-danger'>{t('follow-up.agents.chat-view.error-status')}</span>;
                                }
                            })())
                        }
                    </div>
                )
            },

        },
        {
            name: t('follow-up.agents.chat-view.label-row'),
            sortable: false,
            selector: row => row?.label_ticket,
            cell: row => {
                return (
                    row?.label_ticket ?
                        (
                            <span className="col badge bg-info mx-2">{row?.label_ticket}</span>
                        ) :
                        (
                            <span className="badge bg-danger">{t('follow-up.agents.chat-view.no-label')}</span>
                        )
                )
            },
        },
        // {
        //     name: t('follow-up.agents.chat-view.actions-row'),
        //     sortable: false,
        //     cell: row => {
        //         return <p className="text-nowrap mb-0"></p>
        //     },

        // }
    ]
    const getDetail = async () => {
        const { data } = await call(() => FollowUpService.getAgentDetail(account.id, agentSelected.agent_id));
        setRows(data.conversations);
        setClosedTickets(data.agent_info.tt_close);
        setLiveTickets(data.agent_info.tt_live);
    }

    useEffect(() => {
        if (agentSelected) {
            getDetail();
        }
    }, [agentSelected])
    const heightRequesting = useMemo(()=> {return isRequesting ? 'h-110':''},[isRequesting]);
    return (
        <div className="col-12 p-0">
            <div className="bg-light border h-100 d-flex flex-column">

                <div className="bg-white border-bottom shadow-sm p-18">
                    <div className="d-flex align-items-center">
                        <div className="avatar avatar avatar-circle">
                            <span className="avatar avatar-soft-primary avatar-circle">
                                <span className="avatar-initials">{agentSelected.username[0]}</span>
                                {agentSelected.status.toUpperCase() === 'ONLINE' ? <span className="avatar-status avatar-status-primary"></span> : null}
                            </span>
                        </div>

                        <div className="ms-2 ">
                            <h4 className="mb-0">{agentSelected.username}</h4>
                            <p className="m-0 form-text">{`${agentSelected.time_in_sesion} ${t('follow-up.agents.profile.in-session-time')}`}</p>
                        </div>
                        <div className="ms-auto ">
                            {agentSelected.sub_account ?  
                            <span className="col badge bg-secondary">{agentSelected.sub_account}</span>
                            : 
                            <span className="badge bg-danger badge-sm font-10" >{t('follow-up.agents.profile.no-subaccount')}</span>}
                           
                            <span className="col badge bg-info mx-2">{agentSelected.status_table}</span>
                        </div>
                    </div>
                </div>
                <div className='container-md overflow-scroll'>

                    <div className="flex-grow-1 d-flex flex-column ps-3 pe-3 pt-4 pb-4">
                        <div className={`d-flex row relative ${heightRequesting}`}>
                            {
                                isRequesting ? <LoaderSmall/> :
                            <>
                            <div className='col card-pie card p-0 me-68'>
                                <div className='card-body'>
                                    <h6 className="card-subtitle mb-2">{t('follow-up.agents.chat-view.handled-tickets')}</h6>
                                    <div className='d-flex'>
                                        <h1 className='d-flex align-items-center text-nowrap me-1'>{Object.values(liveTickets).reduce((one, two) => one + two, 0)}</h1>
                                    </div>
                                </div>
                            </div>

                            <div className='col card-pie card p-0'>
                                <div className='card-body'>
                                    <h6 className="card-subtitle mb-2">{t('follow-up.agents.chat-view.closed-tickets')}</h6>
                                    <div className='d-flex '>
                                        <h1 className='d-flex align-items-center text-nowrap me-1'>{Object.values(closedTickets).reduce((one, two) => one + two, 0)}</h1>
                                    </div>
                                </div>
                            </div>
                            </>
                            }
                        </div>
                    </div>
                    <div>
                        <CustomDataTable
                            columns={columns}
                            data={rows}
                            hideAccountsFilter
                            showExport={false}
                            isLoading={isRequesting}
                            filter={(row, term) => {
                                if (!term) return true;
                                return (
                                    `${row.name_client}`.match(new RegExp(`${term}`, 'i')) ||
                                    `${row.chat_number.replace(onlyNumber, '')}`.match(new RegExp(`${term}`, 'i')) ||
                                    `${row._status_ticket}`.match(new RegExp(`${term}`, 'i')) ||
                                    `${row.label_ticket}`.match(new RegExp(`${term}`, 'i'))
                                )
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}
